import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
//import App from './App';
import reportWebVitals from './reportWebVitals';
import Header from './components/Header';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CreditReport from './pages/CreditReport';
import Login from './pages/Login';
import Register from './pages/Register';
import UserProfile from './pages/UserProfile';
import UserProfileMobile from './pages/UserProfileMobile'
import TotAccMob from './pages/TotAccMob';
import CreditCardsMob from './pages/CreditCardsMob';
import HeaderMob from './components/HeaderMob';
import AboutUs from './pages/AboutUs';
import TandC from './pages/TandC';
import Faq from './pages/Faq';
const isMobile = window.innerWidth <= 768;
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    
    <BrowserRouter>
      {isMobile? <HeaderMob />:<Header />}
      <Routes>
        <Route path="/" element={<CreditReport />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/profile" element={isMobile ? <UserProfileMobile />: <UserProfile />} />
        <Route path="/profile/totalAccounts" element={isMobile ? <TotAccMob /> :<></>} />
        <Route path="/profile/creditCards" element={isMobile ? <CreditCardsMob /> :<></>} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/terms" element={<TandC />} />
        <Route path="/faqs" element={<Faq />} />
      </Routes>
    </BrowserRouter>

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
